import { STATUS_CONFIG } from './statusConfig';

export const mapChildToComponentData = (childData) => {
  if (!childData) return null;

  return {
    id: childData._id,
    fullName: `${childData.lastName} ${childData.firstName} ${childData.middleName}`,
    lastName: childData.lastName,
    firstName: childData.firstName,
    middleName: childData.middleName,
    birthDate: childData.birthDate,
    gender: childData.gender,
    
    // Свидетельство о рождении
    birthCertificate: {
      number: childData.birthCertificate?.number,
      issueDate: childData.birthCertificate?.issueDate,
      issuedBy: childData.birthCertificate?.issuedBy
    },
    birthCertificateScan: mapDocument(childData.birthCertificateScan),
    
    // Адреса
    actualAddress: getActualAddress(childData),
    registeredAddress: childData.registeredAddress,
    
    // Статус регистрации
    registrationStatus: childData.statusMR.result == "true" ? 'verified' : 'not_verified',
    registrationVerifiedBy: childData.registrationVerifiedBy,
    registrationVerifiedAt: childData.statusMR.date,
    
    // Льготы
    benefits: mapBenefits(childData.benefits),
    
    // Текущий статус
    currentKindergarten: childData.currentKindergarten?.name,
    previousKindergarten: childData.previousKindergarten?.name,
    currentGroup: childData.currentGroup?.name,
    placeType: childData.currentPlace?.type,
    status: childData.status,
    statusClass: getStatusClass(childData.status),
    
    // Документы
    registrationDocuments: mapDocuments(childData.registrationDocuments),
    
    // История статусов
    history: mapHistory(childData.statuses || []),
    
    // Словари для форматирования адресов
    dictionary: {
      addresses: childData.addresses || {}
    }
  };
};

const mapHistory = (statuses) => {
  if (!statuses) return [];
  
  return statuses.map((status, index) => ({
    id: status._id || `status-${index}`,
    date: status.statusInsertDate,
    state: status.state,
    action: status.action,
    actionBy: status.actionBy,
    kindergarten: status.kindergartenId,
    group: status.groupNumber,
    comment: status.comment,
    details: status.details,
    periodStartYear: status.periodStartYear,
    // Документы приказов
    removalOrder: status.removalOrder,
    detailTransfer: status.detailTransfer,
    enrollmentOrder: status.enrollmentOrder,
    
    // Дополнительные данные для действий
    fromGroup: status.fromGroup,
    toGroup: status.toGroup,
    reason: status.reason,
    fromDate: status.fromDate,
    toDate: status.toDate,
    benefitName: status.benefitName,
    byUser: status.byUser
  }));
};

const getActualAddress = (childData) => {
    
  if (childData.actualAddressDict) {
    const address = childData.actualAddressDict;
    return [address.street?.name, address.building?.name, address.corpus?.name]
      .filter(Boolean)
      .join(', ');
  }

  if(!childData.actualAddress) return childData.address;
  return childData.actualAddress || '';
};

const mapBenefits = (benefits) => {
  if (!benefits) return [];
  
  return benefits.map(benefit => ({
    id: benefit._id,
    benefitName: benefit.benefitName,
    documentType: benefit.documentType,
    documentNumber: benefit.documentNumber,
    documentIssueDate: benefit.documentIssueDate,
    documentTo: benefit.documentTo,
    isActive: benefit.isActive
  }));
};

const mapDocuments = (documents) => {
  if (!documents) return [];
  
  return documents.map((doc, index) => ({
    id: doc._id || `doc-${index}`,
    name: doc.file?.name || `Документ ${index + 1}`,
    type: getFileType(doc.file?.mime),
    size: formatFileSize(doc.file?.size),
    uploadedAt: formatDate(doc.file?.datetimeupload),
    originalName: doc.file?.name
  }));
};

const mapDocument = (doc) => {
  if (!doc) return null;
  
  return {
    id: doc._id,
    name: doc.file?.name,
    type: getFileType(doc.file?.mime),
    size: formatFileSize(doc.file?.size),
    originalName: doc.file?.name
  };
};



const getStatusText = (status) => {
  const statusMap = {
    'active': 'Активний',
    'graduated': 'Випуск',
    'transferred': 'Переведений',
    'left': 'Вибуття',
    'inactive': 'Неактивний'
  };
  return statusMap[status] || status;
};

const getStatusClass = (status) => {
  const classMap = {
    'active': 'status-success',
    'graduated': 'status-verified',
    'transferred': 'status-warning',
    'left': 'status-error',
    'inactive': 'status-pending'
  };
  return classMap[status] || 'status-pending';
};

const getHistoryActionText = (action) => {
  const actionMap = {
    'enrollment': 'Зачислення',
    'transfer': 'Переведення',
    'graduation': 'Випуск',
    'leave': 'Вибуття',
    'group_change': 'Зміна групи'
  };
  return actionMap[action] || action;
};

const getFileType = (mimeType) => {
  const typeMap = {
    'application/pdf': 'pdf',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'application/zip': 'zip'
  };
  return typeMap[mimeType] || 'file';
};

const formatFileSize = (bytes) => {
  if (!bytes) return '0 Б';
  const sizes = ['Б', 'КБ', 'МБ', 'ГБ'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('uk-UA');
};
